export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/51cf28c06ae0cdf89cd5a73dd1812bb3.png";